import React from 'react'

import { faFlaskGear } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import useBetaMode from '../../hooks/useBetaMode'
import { Tooltip } from 'antd'
import { getTranslate } from 'react-localize-redux'
import { connect } from 'react-redux'

const mapStateToProps = state => ({ t: getTranslate(state.locale) })

const BetaStateDisplayer = ({ t }) => {
  const betaMode = useBetaMode()

  return (
    <div className={'ml-10' + (betaMode.active ? ' flex-row ai-ctr jc-ctr mr-10' : '')}>
      {betaMode.active && (
        <Tooltip title={t('beta_mode_displayer.title')} placement='bottomLeft'>
          <FontAwesomeIcon icon={faFlaskGear} />
        </Tooltip>
      )}
    </div>
  )
}

export default connect(mapStateToProps)(BetaStateDisplayer)
